import videojs from 'video.js';
import msgApi from './msg-api.js';
import msgKtvr from './msg-ktvr.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;

const TYPES = {
  api: msgApi,
  ktvr: msgKtvr
};

// Default options for the plugin.
const DEFAULTS = {
  counters: []
};

const checkSupport = function() {
  return window.parent && window.parent.postMessage;
};

/**
 * @function stat
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
const postmessages = function(options) {
  if (!checkSupport()) {
    console.error('videojs-postmessages no support');
    return;
  }

  let options_ = videojs.mergeOptions(DEFAULTS, options);
  // In the plugin function, the value of `this` is a video.js `Player` instance.
    let player = this; // eslint-disable-line no-invalid-this
  
  player.postmessagesSpies = [];

  // create one defaul messanger if no defined 
  let messengers = options_.messengers || [{}];

  messengers.forEach((el) => {
    let type = el.type || 'api';
    let messenger = new TYPES[type](player, el);
    player.postmessagesSpies.push(messenger);
  });
};

// Register the plugin with video.js.
registerPlugin('postmessages', postmessages);

// Include the version number.
postmessages.VERSION = '__VERSION__';

export default postmessages;